export class FileSizeConverter {
  static toString(size: number): string {
    if (size < 1024000) {
      return this.toDecimal((size / 1024).toString(), "0.00") + " KB";
    } else if (size < 1048576000) {
      return this.toDecimal((size / 1048576).toString(), "0.00") + " MB";
    } else {
      return this.toDecimal((size / 1073741824).toString(), "0.00") + " GB";
    }
  }

  private static toDecimal(strDecimal: string, format: string): string {
    const dec = parseFloat(strDecimal);
    const fmt = parseFloat(format);
    if (isNaN(dec) || (format !== "" && isNaN(fmt))) {
       return strDecimal;
    }
    const decsp = strDecimal.split(".");
    let fmtsp;
    if (format !== "") {
      fmtsp = format.split(".");
    } else {
      fmtsp = new Array();
      fmtsp.push("0");
      if ((decsp[0] === "0" || decsp[0] === "-0") && decsp.length === 2) {
        const len = decsp[1].search(/[^0]/);
        if (len >= 0) {
          let newfm = "";
          for (let i = 0; i <= len; i++) {
            newfm += "0";
          }
          fmtsp.push(newfm);
        }
      }
    }
    let ret = "";
    if (decsp[0].length < fmtsp[0].length) {
      ret += fmtsp[0].substring(0, fmtsp[0].length - decsp[0].length);
    }
    ret += decsp[0];
    if (decsp.length === 2 && fmtsp.length === 2) {
      ret += ".";
      if (decsp[1].length < fmtsp[1].length) {
        ret += decsp[1] + fmtsp[1].substring(fmtsp[1].length - decsp[1].length - 1);
      } else {
        ret += decsp[1].substring(0, fmtsp[1].length);
      }
    }
    return ret;
  }
}
